import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="multi-reveal"
export default class extends Controller {
  static values = { hiddenClass: { type: String, default: "hidden" } }

  connect() {
    const params = new URLSearchParams(window.location.search)

    // Reveal the search card if either Ransack 'q' exists or 'search_tab' is present
    const hasSearchQuery = Array.from(params.keys()).some(key => key.startsWith('q['))
    const hasSearchTab = params.has('search_tab')

    if (hasSearchQuery || hasSearchTab) {
      this.openById("search_card")
    }
  }

  toggle(event) {
    event.preventDefault()

    const id = event.currentTarget.getAttribute("aria-controls")
    const target = document.getElementById(id)

    if (!target) return

    // Check if the target is NOT hidden to determine if we are closing or opening
    // el-transition manages the "hidden" class for us.
    const isOpen = !target.classList.contains(this.hiddenClassValue)

    // 1. Close all other open panels first
    this.closeAll(target)

    // 2. Toggle the current target
    if (isOpen) {
      leave(target)
      event.currentTarget.setAttribute("aria-expanded", "false")
    } else {
      enter(target)
      event.currentTarget.setAttribute("aria-expanded", "true")
    }
  }

  openById(id) {
    const target = document.getElementById(id)
    const button = this.element.querySelector(`[aria-controls="${id}"]`)

    if (target && target.classList.contains(this.hiddenClassValue)) {
      // this.closeAll(target)
      enter(target)
      if (button) button.setAttribute("aria-expanded", "true")
    }
  }

  closeAll(exceptTarget = null) {
    const buttons = this.element.querySelectorAll('[aria-controls]')

    buttons.forEach(button => {
      const id = button.getAttribute("aria-controls")
      const target = document.getElementById(id)

      // Close if it exists, is not the one we just clicked, and is currently open
      if (target && target !== exceptTarget && !target.classList.contains(this.hiddenClassValue)) {
        leave(target)
        button.setAttribute("aria-expanded", "false")
      }
    })
  }
}